/*
 * @Description:配置
 * @Author: Xyyyyyy
 * @Date: 2023-06-26 10:39:53
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-07-17 13:28:03
 */
import axios from 'axios'
import { warningPrompt, errorPrompt } from '../utils/promptInfo'
import { backToLogin } from '../utils/login.js'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
})

// 请求拦截器
service.interceptors.request.use((config) => {
  if ($cookies.get('access_token')) {
    config.headers.access_token = $cookies.get('access_token')
    return config
  } else {
    backToLogin()
  }
}, (error) => {
  return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use((response) => {
  const meta = response.data
  if (meta.code === 500) {
    if (response.data.message === '您没有访问权限，请重新登录') {
      backToLogin()
    }
    return warningPrompt(response.data.message)
  } else if (meta.code === 999) {
    backToLogin()
    return warningPrompt(response.data.message)
  } else {
    return response.data
  }
}, (error) => {
  return errorPrompt(error)
})
export default service
